import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Admin } from "../../../constants/entity";
import { DeleteIcon, InfoModal } from "../../../components";
import { useAppTranslation } from "../../../constants/hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAppState } from "../../../constants/hooks/global-hooks";
import { deleteAdminAction } from "../../../actions/admin";
import { QueryKeys } from "../../../constants/query-keys";

type AdminColumnsProps = {
  data: Admin;
};

export function AdminColumns({ data }: AdminColumnsProps) {
  const { t } = useAppTranslation();
  const queryClient = useQueryClient();
  const [state, setState] = useAppState({
    infoModalVisible: false,
  });
  const { mutate, error } = useMutation({
    mutationFn: (id: number) => deleteAdminAction(id),
    onSuccess: (data) => {
      queryClient.invalidateQueries([QueryKeys.adminQuery]);
    },
    onError: () => {
      setState((prevState) => ({ ...prevState, infoModalVisible: true }));
    },
  });

  const handleCloseInfoModal = () => {
    setState((prevState) => ({ ...prevState, infoModalVisible: false }));
  };

  const handleConfirm = (id: number) => {
    mutate(id);
  };

  return (
    <TableRow key={data.id}>
      <TableCell component="th" scope="row" align="center">
        {data.name}
      </TableCell>
      <TableCell align="center">{data.email}</TableCell>
      <TableCell align="center">
        <DeleteIcon
          message={t("delete-admin-popup-message")}
          cancelButtonTitle={t("no")}
          confirmButtonTitle={t("yes")}
          handleConfirm={() => handleConfirm(data.id)}
        />
      </TableCell>
      {state.infoModalVisible && (
        <InfoModal
          severity="error"
          message={t("admin-save-error-message")}
          handleClose={handleCloseInfoModal}
          error={error}
        />
      )}
    </TableRow>
  );
}
